import React from 'react';
import { connect } from 'react-redux';
import Link from '../../../components/Link';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withQuery } from '../../../hoc/withGraphql';
import { flowRight as compose } from 'lodash';

import CommonTable from '../../CommonTable/CommonTable';
import Loader from '../../Loader/Loader';

import messages from '../../../locale/messages';
import { updateStaticPageStatus } from '../../../actions/siteadmin/updateStaticPageStatus';
import getAllStaticPage from './getAllStaticPage.graphql';

import s from './StaticPageManagement.css';
class StaticPageManagement extends React.Component {

  static defaultProps = {
    staticData: [
      { id: 1, label: messages.aboutUsLabel, link: '/about', editLink: '/siteadmin/edit/staticpage/1' },
      { id: 2, label: messages.trustSafety, link: '/safety', editLink: '/siteadmin/edit/staticpage/2' },
      { id: 3, label: messages.termsPrivacy, link: '/privacy', editLink: '/siteadmin/edit/staticpage/4' },
      { id: 4, label: messages.help, link: '/help', editLink: '/siteadmin/edit/staticpage/5' },
      { id: 5, label: messages.cookieStaticPolicy, link: '/cookie-policy', editLink: '/siteadmin/edit/staticpage/6' },
      { id: 6, label: messages.termsOfService, link: '/terms-of-service', editLink: '/siteadmin/edit/staticpage/7' }
    ],
  };

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.pageName) },
      { data: formatMessage(messages.status) },
      { data: formatMessage(messages.preview) },
      { data: formatMessage(messages.editLabel) }
    ]
  }

  tbody = (props) => {
    const { staticData, updateStaticPageStatus, data: { getAllStaticPage } } = props;
    const { formatMessage } = props.intl;

    const updatedStaticData = staticData.map((item) => {
      const extractedId = Number(item.editLink.split('/').pop());
      const pageData = getAllStaticPage?.results?.find((page) => page.id === extractedId);
      return {
        ...item,
        updateId: extractedId,
        isEnable: pageData ? pageData.isEnable : false,
      };
    });

    return updatedStaticData.map((item, key) => {
      return {
        id: key,
        data: [
          { data: item?.id },
          { data: formatMessage(item?.label) },
          {
            data: (
              <select
                value={item?.isEnable}
                onChange={(e) => updateStaticPageStatus(item?.updateId, item?.isEnable)}
              >
                <option value={true}>{formatMessage(messages.enabledLabel)}</option>
                <option value={false}>{formatMessage(messages.disabledLabel)}</option>
              </select>
            ),
          },
          {
            data: (
              <a href={item?.link} target={'_blank'}>
                <FormattedMessage {...messages.preview} />
              </a>
            ),
          },
          {
            data: (
              <Link to={item?.editLink}>
                <FormattedMessage {...messages.editLabel} />
              </Link>
            ),
          }
        ]
      }
    });
  };

  render() {
    const { data: { loading } } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <div>
        {loading && <Loader type={"text"} />}
        {!loading && <CommonTable
          title={formatMessage(messages.staticContentManagement)}
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
        />}
      </div>
    );
  }

}

const mapState = (state) => ({
});

const mapDispatch = {
  updateStaticPageStatus
};

export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState, mapDispatch),
  withQuery(getAllStaticPage,
    {
      options: {
        ssr: false,
        fetchPolicy: 'network-only'
      }
    }),
)(StaticPageManagement);